var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgNp5 = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 41,
    viewBox: "0 0 30 41",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.84 36.514C.936 35.83.29 34.742.29 33.615c0-1.753 1.55-3.323 3.526-3.323.886 0 1.347.222 2.012.683 2.861 2.216 5.538 3.305 8.861 3.305 4.413 0 7.754-2.64 7.754-6.868 0-4.209-3.341-6.627-8.418-6.627-3.785 0-5.762 1.329-6.886 1.329-1.09 0-1.976-.462-3.323-1.33-1.091-.885-1.553-1.772-1.33-3.12l.887-14.38C3.373 1.51 4.702.181 6.474.181h18.404c1.773 0 3.104 1.329 3.104 3.101 0 1.754-1.331 3.102-3.104 3.102H9.574l-.663 9.304c2.012-.664 3.766-1.126 6.443-1.126 7.975 0 14.179 4.21 14.179 12.628 0 8.197-6.204 13.514-14.844 13.514-5.538 0-9.526-1.754-12.849-4.191",
    clipRule: "evenodd"
  })));
};
const Memo = /*#__PURE__*/memo(SvgNp5);
export default Memo;